import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { NegotiationEquipmentCategorySummaryData } from "../types/equipmentCategorySummary.type";

type UseNegotiationEquipmentCategorySummaryType = () => UseQueryResult<NegotiationEquipmentCategorySummaryData[], unknown>;

const useNegotiationEquipmentCategorySummary: UseNegotiationEquipmentCategorySummaryType = () => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: NegotiationEquipmentCategorySummaryData[] } }, unknown, NegotiationEquipmentCategorySummaryData[]>({
    queryKey: ['negotiationsEquipmentCategorySummary'],
    queryFn: () => privateAxios.get(`/negotiations/equipment_category_summary`),
    select: (data) => data?.data?.data,
  });
};

export default useNegotiationEquipmentCategorySummary;
